/***************** TOGGLES *******************/
document.addEventListener('click', (event) => {
  const target = event.target.closest(
    '[data-toggle-target], [data-tab-target], [data-modal-target], [data-toggle-reset], [data-close-outside]'
  );
  if (!target) return;

  if (target.dataset.toggleTarget) {
    slideToggle(event);
  }

  if (target.dataset.tabTarget) {
    tabToggle(event);
  }

  if (target.dataset.modalTarget) {
    modalPop(target);
  }

  if (target.hasAttribute('data-toggle-reset')) {
    console.log('Resetting toggles...');
    document
      .querySelectorAll('[data-toggle-target]')
      .forEach((toggle) => toggle.classList.remove('active'));
    document.querySelectorAll('[data-toggle-content]').forEach((content) => {
      content.classList.remove('active');
      setTimeout(() => (content.style.height = '0px'), 500);
    });
  }

  if (target.hasAttribute('data-close-outside')) {
    const parent = target.closest('[data-toggle-content]');
    if (parent) {
      const toggleTargetName = parent.dataset.toggleContent;
      parent.classList.remove('active');
      document
        .querySelector(`[data-toggle-target="${toggleTargetName}"]`)
        ?.classList.remove('active');
    }
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    const closeItems = document.querySelectorAll('[data-close-outside]');
    closeItems.forEach((item) => {
      const target = item.dataset.closeOutside;
      document
        .querySelector(`[data-toggle-target="${target}"]`)
        .classList.remove('active');
      document
        .querySelector(`[data-toggle-content="${target}"]`)
        .classList.remove('active');

      document.querySelector('[data-close]').removeAttribute('data-close');
    });

    //console.log('Escape key pressed');
  }
});

/***************** SLIDE TOGGLES *******************/
function slideToggle(event) {
  event.preventDefault();
  console.log('slide down toggle');

  const toggles = document.querySelectorAll('[data-toggle-target]');
  const targets = document.querySelectorAll('[data-toggle-content]');
  const target = event.target.dataset.toggleTarget;
  const toggleContainers = document.querySelectorAll(
    `[data-toggle-content="${target}"]`
  );
  const body = document.querySelector('body');

  console.log(toggleContainers.length, 'TOGGLE CONTAINER');

  if (event.target.hasAttribute('data-reset')) {
    toggles.forEach((toggle) => {
      const isSameTarget = toggle.dataset.toggleTarget === target;
      toggle.classList.toggle('active', isSameTarget);
    });

    targets.forEach((content) => {
      if (content.dataset.toggleContent !== target) {
        content.classList.remove('active');
      }
    });
  }

  toggleContainers.forEach((group) => {
    const isOpening = !group.classList.contains('active');

    if (isOpening) {
      console.log('opening');
      toggles.forEach((toggle) => {
        if (toggle.dataset.toggleTarget === target) {
          toggle.classList.add('active');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });

      if (event.target.hasAttribute('data-close-outside')) {
        const closeTarget = event.target.dataset.closeOutside;
        body.setAttribute('data-close', closeTarget);
      }
      group.setAttribute('aria-hidden', 'false');
      group.style.height = '0px';
      group.classList.add('active');
      

      const height = group.scrollHeight + 'px';

      requestAnimationFrame(() => {
        group.style.height = height;
      });

      group.addEventListener(
        'transitionend',
        function handleOpenEnd() {
          //group.style.height = 'auto';
          group.style.maxHeight = 'none'; // Firefox Fix
        },
        { once: true }
      );
    } else {
      group.addEventListener('transitionend', e => console.log('Transitioned:', e.propertyName));

      console.log('close toggle');
      toggles.forEach((toggle) => {
        if (toggle.dataset.toggleTarget === target) {
          toggle.classList.remove('active');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });

      body.removeAttribute('data-close');
      const height = group.scrollHeight + 'px';
      group.style.height = height;
      console.log(height, 'HEIGHT');

      requestAnimationFrame(() => {
        group.style.height = '0px';
      });

      group.addEventListener(
        'transitionend',
        function handleCloseEnd() {
          console.log('transition End');
          group.classList.remove('active');
          // group.style.height = 'auto';
          group.setAttribute('aria-hidden', 'true');
        },
        { once: true }
      ); 
    }
  });
}



/*************** TAB TOGGLES ***********/
function tabToggle(event) {
  event.preventDefault();

  const target = event.target.dataset.tabTarget;
  const tabGroup = event.target.dataset.tabGroup;
  const tabs = document.querySelectorAll(
    `[data-tab-target][data-tab-group="${tabGroup}"]`
  );
  const panels = document.querySelectorAll(
    `[data-tab-content][data-tab-group="${tabGroup}"]`
  );
  const isMobileToggle =
    event.target.hasAttribute('data-mobile-toggle') && window.innerWidth < 749;

  // Reset all tabs and panels
  tabs.forEach((tab) => {
    tab.classList.remove('active');
    tab.setAttribute('aria-selected', 'false');
    tab.setAttribute('tabindex', '-1');
  });

  panels.forEach((panel) => {
    panel.classList.remove('active');
    panel.setAttribute('hidden', 'true');
  });

  if (isMobileToggle && event.target.classList.contains('active')) {
    // Close the tab if it's already active
    event.target.classList.remove('active');
    event.target.setAttribute('aria-selected', 'false');
  } else {
    // Activate the selected tab
    event.target.classList.add('active');
    event.target.setAttribute('aria-selected', 'true');
    event.target.setAttribute('tabindex', '0');

    // Show the associated panel(s)
    document
      .querySelectorAll(
        `[data-tab-content="${target}"][data-tab-group="${tabGroup}"]`
      )
      .forEach((content) => {
        content.classList.add('active');
        content.removeAttribute('hidden');

        // Optional: resize Flickity sliders
        const sliders = content.querySelectorAll('.bd-slider');
        sliders.forEach((slider) => {
          const sliderData = Flickity.data(slider);
          if (sliderData) sliderData.resize();
        });
      });
  }
}

// MODAL TOGGLING
let lastFocusedElement = null;
let trapFocusHandler = null;
let escapeListener = null;
let outsideClickListener = null;

function modalPop(trigger) {
  console.log(trigger, 'target');
  const noOverflow = trigger.hasAttribute('data-no-overflow') ? true : false;
  lastFocusedElement = document.activeElement;
  const modalContent = document.querySelector(
    `[data-modal-content="${trigger.dataset.modalTarget}"]`
  );
  if (!modalContent) return console.error('Modal not found!');

  modalContent.setAttribute('tabindex', '-1');
  modalContent.removeAttribute('inert');
  modalContent.removeAttribute('aria-hidden');
  console.log(modalContent, 'modalContent');
  const focusableSelectors = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ];
  const focusableElements = Array.from(
    modalContent.querySelectorAll(focusableSelectors.join(','))
  ).filter((el) => el.offsetParent !== null);

  const firstFocusable = focusableElements[0];
  const lastFocusable = focusableElements[focusableElements.length - 1];

  (firstFocusable || modalContent).focus();

  // Trap focus
  trapFocusHandler = createTrapFocusHandler(modalContent);
  document.addEventListener('keydown', trapFocusHandler);

  // Escape key listener
  escapeListener = (e) => {
    if (e.code === 'Escape') closeModal(modalContent);
  };
  window.addEventListener('keyup', escapeListener);

  // Outside click listener
  outsideClickListener = (event) => {
    if (event.target === modalContent) closeModal(modalContent);
  };
  window.addEventListener('click', outsideClickListener);

  // Close buttons
  modalContent
    .querySelectorAll('[data-close]')
    .forEach((btn) =>
      btn.addEventListener('click', () => closeModal(modalContent))
    );

  // Optional: slider init
  const slider = modalContent.querySelector('.bd-slider');
  if (slider) {
    // initSlider(slider); // abstract if needed
  }

  modalContent.classList.add('active');
  if (!noOverflow) {
    document.body.classList.add('overflow-hidden');
  }
}

function stopVideos() {
  document.querySelectorAll('iframe').forEach((v) => {
    v.src = v.src;
  });
  document.querySelectorAll('video').forEach((v) => {
    v.pause();
  });
}

function closeModal(modal) {
  modal.classList.remove('active');
  document.body.classList.remove('overflow-hidden');
  modal.setAttribute('aria-hidden', 'true');
  modal.setAttribute('inert', '');
  // Remove listeners
  if (trapFocusHandler)
    document.removeEventListener('keydown', trapFocusHandler);
  if (escapeListener) window.removeEventListener('keyup', escapeListener);
  if (outsideClickListener)
    window.removeEventListener('click', outsideClickListener);

  // Restore focus
  if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
    lastFocusedElement.focus();
  }

  // Cookie logic
  const cookie = modal.dataset.cookieModal || false;
  const days = modal.dataset.cookieExpires || 5;
  if (cookie) {
    setCookie(cookie, 'seen', days);
  }

  stopVideos();
  restoreElement(modal);
}

function createTrapFocusHandler(modalContent) {
  return function trapFocusHandler(event) {
    if (event.key !== 'Tab') return;

    const focusableElements = Array.from(
      modalContent.querySelectorAll(
        'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
      )
    ).filter((el) => el.offsetParent !== null);

    if (focusableElements.length === 0) {
      event.preventDefault();
      return;
    }

    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];

    console.log(firstFocusable, 'First Focus');
    console.log(lastFocusable, 'LastFocus');

    if (focusableElements.length === 1) {
      event.preventDefault();
      firstFocusable.focus();
      return;
    }

    if (event.shiftKey) {
      if (
        document.activeElement === firstFocusable ||
        document.activeElement === modalContent
      ) {
        event.preventDefault();
        lastFocusable.focus();
      }
    } else {
      if (document.activeElement === lastFocusable) {
        event.preventDefault();
        firstFocusable.focus();
      }
    }
  };
}

function repositionModal(elementToMove) {
  document.body.insertBefore(elementToMove, document.body.firstChild);
}

// To restore the element to its original position
function restoreElement(elementToMove) {
  const originalParent = elementToMove.parentNode;
  const originalNextSibling = elementToMove.nextSibling;
  if (originalNextSibling) {
    originalParent.insertBefore(elementToMove, originalNextSibling);
  } else {
    originalParent.appendChild(elementToMove);
  }
}

function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + date.toUTCString();
  document.cookie = name + '=' + value + ';' + expires + ';path=/';
}
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}
/* LEFT RIGHT ARROW */
document.querySelectorAll('[role="tab"]').forEach((tab) => {
  tab.addEventListener('keydown', (e) => {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;

    const tabGroup = tab.dataset.tabGroup;
    if (!tabGroup) return;

    const tabs = Array.from(
      document.querySelectorAll(`[role="tab"][data-tab-group="${tabGroup}"]`)
    );
    const currentIndex = tabs.indexOf(tab);

    let newIndex;
    if (e.key === 'ArrowRight') {
      newIndex = (currentIndex + 1) % tabs.length;
    } else if (e.key === 'ArrowLeft') {
      newIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    }

    const newTab = tabs[newIndex];

    // Optional accessibility updates
    tabs.forEach((t, i) => {
      t.setAttribute('tabindex', i === newIndex ? '0' : '-1');
      t.setAttribute('aria-selected', i === newIndex ? 'true' : 'false');
    });

    newTab.focus();
    newTab.click();

    console.log(
      `Tab group: ${tabGroup}, Current index: ${currentIndex}, New index: ${newIndex}`
    );
  });
});
